<div class="news-menu-container">
  <div class="card-header">
    <div class="news-menu-header-text">{{ 'NEWS' | translate | uppercase}}</div>
  </div>
  <div class="news-menu-info-container">
    <app-news-content *ngFor="let news of allNews;" [news]="news"></app-news-content>
  </div>
</div>
